import Story from '../components/StoryPage';

const StoryPage = () => {
	return (
		<Story />
	)
}

export default StoryPage;